import { Separator } from "@chakra-ui/react-v3";
import { ResourceAnalysis } from "../components/resource-analysis";
import { DocumentsSection } from "../components/side-panel-sections/documents-section";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { RelatedPersonRowData } from "../tables/related-person";

export type RelatedPersonSidePanelContentProps = {
  data: RelatedPersonRowData;
};

export function RelatedPersonSidePanelContent({ data }: RelatedPersonSidePanelContentProps) {
  return (
    <SidePanelLayout title="Related Person" subtitle={data.name}>
      <ResourceAnalysis />

      <Separator borderColor="border" />

      <DocumentsSection resources={[data.originalData]} resourceType="RelatedPerson" />
    </SidePanelLayout>
  );
}
